import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { EstudioCientificoService } from 'src/app/core/services/estudio-cientifico/estudio-cientifico.service';
import { CenterModel } from 'src/app/core/models/masters/center.model';
import { MODAL_DIALOG_TYPES } from 'src/app/core/utils/modal-dialog-types';
import { DetalleCentroEstudioComponent } from './detalle-centro-estudio/detalle-centro-estudio.component';
import { DashboardGlobalModalComponent } from './dashboard-estudio/dashboard-global-modal.component';

@Component({
	selector: 'app-estudio-cientifico',
	templateUrl: './estudio-cientifico.component.html',
	styleUrls: ['./estudio-cientifico.component.scss'],
	encapsulation: ViewEncapsulation.None,
	standalone: false
})
export class EstudioCientificoComponent implements OnInit {

	centers: CenterModel[] = [];
	filteredCenters: CenterModel[] = [];
	pagedCenters: CenterModel[] = [];
	searchTerm: string = '';
	loading: boolean = false;

	sortColumn: string = 'name';
	sortDirection: 'asc' | 'desc' = 'asc';

	currentPage: number = 1;
	pageSize: number = 50;
	totalPages: number = 1;

	editingCenterId: number | null = null;
	editData: any = {};
	savingCenter: boolean = false;

	constructor(
		public activeModal: NgbActiveModal,
		private estudioService: EstudioCientificoService,
		private modalService: NgbModal
	) {}

	ngOnInit() {
		this.loadCenters();
	}

	closeModal() {
		this.activeModal.close();
	}

	loadCenters() {
		this.loading = true;
		this.estudioService.getAllCentersEstudio().subscribe({
			next: (res) => {
				console.log('[EstudioCientifico] Response:', res);
				if (res && res.data) {
					this.centers = res.data;
				} else if (Array.isArray(res)) {
					this.centers = res;
				}
				this.applyFilter();
				this.loading = false;
			},
			error: (err) => {
				console.error('[EstudioCientifico] Error cargando centros:', err);
				this.loading = false;
			}
		});
	}

	applyFilter() {
		const term = this.searchTerm.toLowerCase().trim();
		if (!term) {
			this.filteredCenters = [...this.centers];
		} else {
		this.filteredCenters = this.centers.filter(c =>
			c.name?.toLowerCase().includes(term) ||
			c.centerName?.toLowerCase().includes(term) ||
			c.centerAddress?.toLowerCase().includes(term) ||
			c.centerCountry?.toLowerCase().includes(term) ||
			c.centerMail?.toLowerCase().includes(term)
		);
		}
		this.applySorting();
		this.currentPage = 1;
		this.updatePage();
	}

	onSearch() {
		this.applyFilter();
	}

	sort(column: string) {
		if (this.sortColumn === column) {
			this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
		} else {
			this.sortColumn = column;
			this.sortDirection = 'asc';
		}
		this.applySorting();
		this.updatePage();
	}

	private applySorting() {
		const dir = this.sortDirection === 'asc' ? 1 : -1;
		this.filteredCenters.sort((a: any, b: any) => {
			const valA = a[this.sortColumn] ?? '';
			const valB = b[this.sortColumn] ?? '';
			if (valA < valB) return -1 * dir;
			if (valA > valB) return 1 * dir;
			return 0;
		});
	}

	getSortIcon(column: string): string {
		if (this.sortColumn !== column) return '↕';
		return this.sortDirection === 'asc' ? '↑' : '↓';
	}

	updatePage() {
		this.totalPages = Math.ceil(this.filteredCenters.length / this.pageSize) || 1;
		const start = (this.currentPage - 1) * this.pageSize;
		this.pagedCenters = this.filteredCenters.slice(start, start + this.pageSize);
	}

	goToPage(page: number) {
		if (page < 1 || page > this.totalPages) return;
		this.currentPage = page;
		this.updatePage();
	}

	startEdit(center: any) {
		this.editingCenterId = center.idCenter;
		this.editData = {
			name: center.name || '',
			centerName: center.centerName || '',
			centerAddress: center.centerAddress || '',
			centerCountry: center.centerCountry || '',
			centerMail: center.centerMail || '',
			centerPhone: center.centerPhone || ''
		};
	}

	cancelEdit() {
		this.editingCenterId = null;
		this.editData = {};
	}

	saveEdit(center: any) {
		this.savingCenter = true;
		const payload = {
			idCenter: center.idCenter,
			name: this.editData.name,
			centerName: this.editData.centerName,
			centerAddress: this.editData.centerAddress,
			centerCountry: this.editData.centerCountry,
			centerMail: this.editData.centerMail,
			centerPhone: this.editData.centerPhone
		};

		this.estudioService.updateCenter(center.idCenter, payload).subscribe({
			next: (res) => {
				center.name = this.editData.name;
				center.centerName = this.editData.centerName;
				center.centerAddress = this.editData.centerAddress;
				center.centerCountry = this.editData.centerCountry;
				center.centerMail = this.editData.centerMail;
				center.centerPhone = this.editData.centerPhone;
				this.editingCenterId = null;
				this.editData = {};
				this.savingCenter = false;
			},
			error: (err) => {
				console.error('[EstudioCientifico] Error actualizando centro:', err);
				this.savingCenter = false;
			}
		});
	}

	verDetalleCentro(center: CenterModel) {
		const modalRef = this.modalService.open(DetalleCentroEstudioComponent, {
			scrollable: true,
			windowClass: `${MODAL_DIALOG_TYPES.W90} h-100`,
		});
		modalRef.componentInstance.idCenter = center.idCenter;
		modalRef.componentInstance.centerName = center.centerName;
	}

	verDashboardGlobal() {
		this.modalService.open(DashboardGlobalModalComponent, {
			scrollable: true,
			windowClass: `${MODAL_DIALOG_TYPES.W90} h-100`,
		});
	}
}
